export default __webpack_public_path__ + "static/ventilator_w.ffc460d50460bb167ad55529ee851cdd.png";